// Need to use the React-specific entry point to import createApi
import isBoolean from 'lodash/isBoolean';

import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const fileApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFiles: builder.query({
      query: filters => {
        const qs = new URLSearchParams();
        if (filters.patient_id) qs.set('patient_id', filters.patient_id);
        if (filters.id) qs.set('id', filters.id);
        if (filters.include_hidden_files) qs.set('include_hidden_files', 'true');
        if (filters.include_incomplete_files) qs.set('include_incomplete_files', 'true');
        if (filters.lead_id) qs.set('lead_id', filters.lead_id);
        return `file/?${qs}`;
      },
      providesTags: ['File', 'Claim'],
    }),
    createFile: builder.mutation({
      query: body => ({
        url: 'file/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['File', 'Claim'],
    }),
    updateFile: builder.mutation({
      query: ({ id, body }) => ({
        url: `file/${id}/`,
        method: 'PUT',
        body: body,
      }),
      invalidatesTags: ['File'],
    }),
    removeFile: builder.mutation({
      query: ({ id }) => ({
        url: `file/${id}/`,
        method: 'DELETE',
      })
    }),
    invalidatesTags: ['File'],
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFilesQuery,
  useCreateFileMutation,
  useUpdateFileMutation,
  useRemoveFileMutation
} = fileApi;
